<template>
    <div class="p-12">
        <prime-skeleton />
    </div>
</template>

<script setup lang="ts">
import {
    definePageMeta,
    useRpQuery,
    useSetViewer,
    useShowAlert,
    watch
} from '#imports'
import PrimeSkeleton from 'primevue/skeleton'
import { useI18n } from 'vue-i18n'
import { graphql } from '~/resources/graphql'
import { useMobileAppData } from '~/composables/mobile/mobile-app-data'
import { usePostMessageCapacitor } from '~/composables/mobile/post-message'

definePageMeta({
    layout: false
})

const query = useRpQuery({ orgLevel: true })
const setViewer = useSetViewer()
const showAlert = useShowAlert()
const { t } = useI18n({ useScope: 'global' })
const mobileAppData = useMobileAppData()
const { postReadyForDeepLink } = usePostMessageCapacitor()

// When the bearer token has been received, set the viewer
watch(
    () => mobileAppData.value.bearerToken,
    async newValue => {
        if (newValue !== null) {
            const data = await query(
                graphql(/* GraphQL */ `
                    query AwaitAccessTokenProvideViewer {
                        viewer {
                            ...ViewerFragment
                        }
                    }
                `)
            )

            if (data !== undefined) {
                if (data.viewer !== null) {
                    setViewer(data.viewer)
                    // Capacitor responds with either the profile page or a deep link destination
                    // Then our CPX handler handles navigation away from this page
                    postReadyForDeepLink()
                } else {
                    await showAlert(
                        t('notFound.somethingWentWrong'),
                        t('pages.viewerNotFound')
                    )
                    setViewer(undefined)
                }
            }
        }
    }
)
</script>
